import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { FileText, AlertTriangle, Search } from "lucide-react";
import api, { fmtDate } from "../lib/api";
import { FileAzioni } from "../components/FileViewer";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { toast } from "sonner";

export default function DocumentiArchivio() {
  const { selectedStructure } = useAuth();
  const [search, setSearch] = useState("");
  const { data = [] } = useQuery({ queryKey: ["doc-archive", selectedStructure], queryFn: async () => (await api.get("/documenti", { params: { structure_id: selectedStructure } })).data });
  const { data: scadenze = [] } = useQuery({ queryKey: ["doc-scadenze", selectedStructure], queryFn: async () => (await api.get("/documenti/scadenze", { params: { structure_id: selectedStructure } })).data });

  const filtered = data.filter((d) => !search || JSON.stringify(d).toLowerCase().includes(search.toLowerCase()));
  const ownerLabel = { ospite: "Ospite", operatore: "Operatore", struttura: "Struttura" };

  return (
    <div>
      <h1 className="text-2xl font-head font-bold mb-1">Documenti e scadenze</h1>
      <p className="text-sm text-muted-foreground mb-5">Archivio documentale centralizzato con accessi protetti</p>

      {scadenze.length > 0 && (
        <div className="gr-card p-4 mb-5 border-l-4" style={{ borderLeftColor: "#dc2626" }} data-testid="scadenze-panel">
          <div className="flex items-center gap-2 font-head font-bold text-red-700 mb-2"><AlertTriangle size={18} /> {scadenze.length} documenti in scadenza (30 giorni)</div>
          <div className="flex flex-wrap gap-2">
            {scadenze.map((s) => <span key={s.id} className="text-xs px-2 py-1 rounded bg-red-50 text-red-800 font-medium">{s.titolo} — {fmtDate(s.data_scadenza)}</span>)}
          </div>
        </div>
      )}

      <div className="relative w-64 mb-3">
        <Search size={16} className="absolute left-3 top-3 text-muted-foreground" />
        <Input placeholder="Cerca documento..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-9" data-testid="search-documenti" />
      </div>
      <div className="gr-card overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-secondary/60"><TableHead className="font-bold">Titolo</TableHead><TableHead className="font-bold">Categoria</TableHead><TableHead className="font-bold">Collegato a</TableHead><TableHead className="font-bold">Caricato</TableHead><TableHead className="font-bold">Scadenza</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {filtered.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">Nessun documento</TableCell></TableRow>}
            {filtered.map((d) => (
              <TableRow key={d.id} data-testid={`archive-doc-${d.id}`}>
                <TableCell className="font-semibold flex items-center gap-2"><FileText size={15} className="text-primary" /> {d.titolo}</TableCell>
                <TableCell>{d.categoria || "—"}</TableCell>
                <TableCell>{ownerLabel[d.owner_type] || d.owner_type} {d.owner_nome ? `· ${d.owner_nome}` : ""}</TableCell>
                <TableCell>{fmtDate(d.created_at)}</TableCell>
                <TableCell>{d.data_scadenza ? fmtDate(d.data_scadenza) : "—"}</TableCell>
                <TableCell><FileAzioni url={`/documenti/${d.id}/download`} titolo={d.original_filename || d.titolo || "documento"} testid={`arch-${d.id}`} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
